import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-text-input',
  imports: [],
  templateUrl: './rid-text-input.html',
  host: {
    class: 'block',
  },
})
export class RidTextInput {
  appearance = input<'DEFAULT' | 'CORRECT' | 'INCORRECT'>('DEFAULT');
}
